<template>
  <div class="animated fadeIn">
    <b-modal
      ref="modal-crmCard"
      modal-class="modal-fullscreen"
      @hide="hideModal"
      :hide-header-close="false"
      :hide-footer="true"
      :hide-header="true"
      scrollable
    >
      <div class="close__btn d-flex" @click="hideModal">
        <i
          style="background-color: #e5e5e5; border-radius: 999px;"
          class="far fa-times-circle"
        ></i>
      </div>
      <div class="container-fluid h-100">
        <div class="row h-100">
          <div
            :class="
              card &&
              card.situacao === 'ATIVO' &&
              !card.boardColumn.board.arquivado &&
              !card.boardColumn.board.isReadOnly
                ? 'col-md-5'
                : 'col-md-6'
            "
            class="scrollContainer nx-scrollbar nx-scrollbar-default"
          >
            <InvalidDocumentAlert
              v-if="card"
              :personDocument="card.pessoa.document"
            />
            <RestrictionAlert
              style="margin-bottom: .2rem"
              v-if="person"
              :personDocument="person.document"
            />
            <DetailContainer
              :defaultOpen="true"
              componentTitle="Informações Pessoais"
              componentIcon="fas fa-user"
              :customActionIcon="cardActive ? 'fas fa-pen' : ''"
              :customActionFunction="cardActive ? openEditPerson : null"
            >
              <template v-if="this.person">
                <div>
                  <span
                    v-b-tooltip.hover="'Clique para copiar'"
                    @click="onCopy(person.nome)"
                    ><strong>Nome: </strong>{{ this.person.nome }}</span
                  >

                  <div class="d-flex justify-content-between mb-2 mt-2">
                    <span
                      v-b-tooltip.hover="'Clique para copiar'"
                      @click="onCopy(person.document)"
                      ><strong
                        >{{
                          this.personType === "Pessoa Física" ? "CPF" : "CNPJ"
                        }}: </strong
                      >{{ onFormatDocument(this.person.document) }}</span
                    >
                    <span
                      v-b-tooltip.hover="'Clique para copiar'"
                      @click="
                        onCopy(
                          moment
                            .utc(person.dataNascimento, moment.ISO_8601)
                            .format('DD/MM/YYYY')
                        )
                      "
                      v-if="this.person.dataNascimento"
                      ><strong
                        >Data
                        {{
                          this.personType === "Pessoa Física"
                            ? "Nascimento"
                            : "Criação"
                        }}: </strong
                      >{{
                        moment
                          .utc(this.person.dataNascimento, moment.ISO_8601)
                          .format("DD/MM/YY")
                      }}</span
                    >
                  </div>
                  <div class="d-flex justify-content-between ">
                    <span><strong>Tipo: </strong>{{ this.personType }}</span>
                    <span v-if="this.card.origemLead"
                      ><strong>Origem: </strong
                      >{{ this.card.origemLead.nome }}</span
                    >
                  </div>
                  <div
                    v-if="card.alreadyAssociate"
                    class="d-flex justify-content-between mb-2 mt-4"
                  >
                    <b-link @click="openAssociatePage">
                      <i class="fas fa-external-link-square-alt"></i>
                      Página do associado
                    </b-link>
                  </div>
                </div>
              </template>
              <b-skeleton-wrapper v-if="!this.person">
                <template>
                  <b-skeleton class="mb-2" width="80%"></b-skeleton>
                  <b-skeleton class="mb-2" width="90%"></b-skeleton>
                  <b-skeleton width="60%"></b-skeleton>
                </template>
              </b-skeleton-wrapper>
              <InfoPersonModal
                v-if="card && editPersonInfo"
                ref="InfoPersonModal"
                :card="card"
                :boardArchived="boardArchived"
                v-on:Reload="closeEditPerson"
              />
            </DetailContainer>
            <DetailContainer v-if="hasSerasaConsult(card)" componentTitle="Consulta Serasa" componentIcon="fas fa-search-dollar" :defaultOpen="true" >
              <CrmDetailsSerasa @Reload="onLoadLead" :serasa="card.pessoa.serasa" />
            </DetailContainer>
            <DetailContainer v-if="isAjuizamento(card)" componentTitle="Ajuizamento" componentIcon="fas fa-gavel" :defaultOpen="true" >
              <CrmDetailsAjuizamento @Reload="onLoadLead" :ajuizamentos="person && person.ajuizamentos"/>
            </DetailContainer>
            <DetailContainer
              :defaultOpen="true"
              componentTitle="Campanha"
              componentIcon="fas fa-comments"
              v-if="(card && card.campanhas.length > 0) || (card && checkCardHasWebsocketCampaign(card))"
            >
              <CrmDetailsCampanha
                ref="CrmDetailsCampanha"
                :card="card"
              />
            </DetailContainer>
            <DetailContainer
              v-if="card"
              :defaultOpen="card.observacao != null ? true : false"
              componentTitle="Observações"
              componentIcon="fas fa-comments"
            >
              <CrmDetailsObservation
                ref="CrmDetailsObservation"
                :cardActive="cardActive"
                :card="card"
                v-on:Reload="onLoadLead"
              />
            </DetailContainer>
            <template v-if="isMobile">
              <DetailContainer
                :defaultOpen="true"
                componentTitle="Atividades"
                componentIcon="fas fa-undo"
                :customActionIcon="cardActive ? 'fas fa-plus-circle' : ''"
                :customActionFunction="cardActive ? openNewFollowUp : null"
              >
                <CrmDetailsTimeline
                  ref="CrmDetailsTimeline"
                  v-if="card"
                  :card="card"
                  v-on:Reload="onReloadBoardAndFollowUp"
                />
              </DetailContainer>
              <DetailContainer
                :defaultOpen="false"
                componentTitle="Indicadores"
                componentIcon="fas fa-chart-pie"
              >
                <CrmDetailsInfo
                  v-show="card"
                  ref="CrmDetailsInfo"
                  :card="card"
                />
                <b-skeleton-wrapper v-if="!card">
                  <template>
                    <div
                      class="d-flex align-items-center justify-content-start "
                    >
                      Protocolo:
                      <b-skeleton class="ml-1" width="40%"></b-skeleton>
                    </div>
                    <div
                      class="d-flex align-items-center justify-content-start "
                    >
                      Criado por:
                      <b-skeleton class="ml-1" width="40%"></b-skeleton>
                    </div>
                    <div
                      class="d-flex align-items-center justify-content-start mt-3"
                    >
                      <b-skeleton
                        class="mr-3"
                        style="border-radius:8px"
                        type="avatar"
                        width="113px"
                        height="95px"
                      ></b-skeleton>
                      <b-skeleton
                        class="mr-3"
                        style="border-radius:8px"
                        type="avatar"
                        width="113px"
                        height="95px"
                      ></b-skeleton>
                      <b-skeleton
                        class="mr-3"
                        style="border-radius:8px"
                        type="avatar"
                        width="113px"
                        height="95px"
                      ></b-skeleton>
                    </div>
                  </template>
                </b-skeleton-wrapper>
              </DetailContainer>
            </template>
            <DetailContainer
              componentTitle="Contatos"
              componentIcon="fas fa-address-book"
              :customActionIcon="cardActive ? 'fas fa-plus-circle' : ''"
              :customActionFunction="cardActive ? openAddPhone : null"
            >
              <CrmDetailsContacts
                ref="CrmDetailsContacts"
                :card="card"
                :phones="person && person.telefone"
                :boardArchived="boardArchived"
                v-on:Reload="onReloadPersonAndFollowup"
              />
            </DetailContainer>
            <DetailContainer
              componentTitle="Produtos"
              componentIcon="fas fa-wallet"
              :customActionIcon="cardActive ? 'fas fa-plus-circle' : ''"
              :customActionFunction="cardActive ? openAddProduct : null"
            >
              <CrmDetailsProduct
                ref="CrmDetailsProduct"
                :card="card"
                :boardArchived="boardArchived"
                v-on:Reload="onReloadBoardAndFollowUp"
              />
            </DetailContainer>
            <DetailContainer
              componentTitle="Logradouro"
              componentIcon="fas fa-map-marker-alt"
              :customActionIcon="cardActive ? 'fas fa-plus-circle' : ''"
              :customActionFunction="cardActive ? openAddAddress : null"
            >
              <CrmDetailsAddress
                ref="CrmDetailsAddress"
                :card="card"
                :address="person && person.endereco"
                :boardArchived="boardArchived"
                v-on:Reload="onReloadPersonAndFollowup"
              />
            </DetailContainer>
            <DetailContainer
              componentTitle="Responsável"
              componentIcon="fas fa-user-cog"
            >
              <CrmDetailsLeadOwner
                ref="CrmDetailsLeadOwner"
                :card="card"
                :boardArchived="boardArchived"
                v-on:updatedLeadOwners="updateBoardAndPerson"
              />
            </DetailContainer>
          </div>
          <div
            v-if="!isMobile"
            :class="
              card &&
              card.situacao === 'ATIVO' &&
              !card.boardColumn.board.arquivado &&
              !card.boardColumn.board.isReadOnly
                ? 'col-md-5'
                : 'col-md-6'
            "
            class="scrollContainer nx-scrollbar nx-scrollbar-default"
          >
            <DetailContainer
              :defaultOpen="false"
              componentTitle="Indicadores"
              componentIcon="fas fa-chart-pie"
            >
              <CrmDetailsInfo v-show="card" ref="CrmDetailsInfo" :card="card" />
              <b-skeleton-wrapper v-if="!card">
                <template>
                  <div class="d-flex align-items-center justify-content-start ">
                    Protocolo:
                    <b-skeleton class="ml-1" width="40%"></b-skeleton>
                  </div>
                  <div class="d-flex align-items-center justify-content-start ">
                    Criado por:
                    <b-skeleton class="ml-1" width="40%"></b-skeleton>
                  </div>
                  <div
                    class="d-flex align-items-center justify-content-start mt-3"
                  >
                    <b-skeleton
                      class="mr-3"
                      style="border-radius:8px"
                      type="avatar"
                      width="113px"
                      height="95px"
                    ></b-skeleton>
                    <b-skeleton
                      class="mr-3"
                      style="border-radius:8px"
                      type="avatar"
                      width="113px"
                      height="95px"
                    ></b-skeleton>
                    <b-skeleton
                      class="mr-3"
                      style="border-radius:8px"
                      type="avatar"
                      width="113px"
                      height="95px"
                    ></b-skeleton>
                  </div>
                </template>
              </b-skeleton-wrapper>
            </DetailContainer>
            <DetailContainer
              :defaultOpen="true"
              componentTitle="Atividades"
              componentIcon="fas fa-undo"
              :customActionIcon="cardActive ? 'fas fa-plus-circle' : ''"
              :customActionFunction="cardActive ? openNewFollowUp : null"
            >
              <CrmDetailsTimeline
                ref="CrmDetailsTimeline"
                v-if="card"
                :card="card"
                v-on:Reload="onReloadBoardAndFollowUp"
              />
            </DetailContainer>
          </div>
          <div
            class="col-md-2"
            v-if="
              card &&
                card.situacao === 'ATIVO' &&
                !card.boardColumn.board.arquivado &&
                !isTablet &&
                !card.boardColumn.board.isReadOnly
            "
          >
            <h5 class="actions__buttons__tittle">AÇÕES</h5>
            <DefaultButton
              :onClick="openNewFollowUp"
              btnVariant="btn-fifth"
              icon="fas fa-plus"
              text="follow-up"
            />
            <DefaultButton
              :onClick="openNewCardDescription"
              btnVariant="btn-outline-fifth"
              icon="fas fa-file-signature"
              text="Descrição"
            />
            <template v-if="!isVisita">
              <hr />
              <DefaultButton
                :onClick="() => manageSituation(cardSituation.GANHO)"
                btnVariant="btn-success"
                icon="fas fa-user-check"
                text="ganho"
              />
              <DefaultButton
                :onClick="() => manageSituation(cardSituation.PERDIDO)"
                btnVariant="btn-danger"
                icon="fas fa-user-times"
                text="perdido"
              />
              <DefaultButton
                :onClick="() => manageSituation(cardSituation.FINALIZADO)"
                btnVariant="btn-outline-third"
                icon="fas fa-user-slash"
                text="finalizar"
              />
              <DefaultButton
                :onClick="() => manageSituation('DELETE')"
                btnVariant="btn-outline-third"
                icon="fas fa-user-minus"
                text="cancelar"
              />
              <hr />
              <DefaultButton
                :onClick="openMoveCard"
                id="moveBtn"
                btnVariant="btn-third"
                icon="fas fa-arrow-right"
                text="mover"
              />
              <DefaultButton
                :onClick="openMoveCardBoard"
                id="moveBoardBtn"
                btnVariant="btn-third"
                icon="fas fa-arrow-right"
                text="trocar quadro"
              />
            </template>
          </div>
          <vue-fab
            v-if="isMobile || isTablet"
            size="big"
            id="fabMobile"
            icon="add"
            mainBtnColor="#04a791"
            class
            :scrollAutoHide="false"
          >
            <fab-item
              :idx="6"
              title="Follow-up"
              color="#6940AB"
              icon="add"
              @clickItem="openNewFollowUp"
            ></fab-item>
            <fab-item
              :idx="6"
              title="Descrição"
              color="#6940AB"
              icon="add"
              @clickItem="openNewCardDescription"
            ></fab-item>
            <template v-if="!isVisita">
              <fab-item
                :idx="5"
                title="Ganho"
                color="#00C851"
                icon="done"
                @clickItem="manageSituation(cardSituation.GANHO)"
              ></fab-item>
              <fab-item
                :idx="4"
                title="Perdido"
                icon="close"
                color="#FF4444"
                @clickItem="manageSituation(cardSituation.PERDIDO)"
              ></fab-item>
              <fab-item
                :idx="3"
                title="Finalizar"
                icon="person_off"
                color="#4285f4"
                @clickItem="manageSituation(cardSituation.FINALIZADO)"
              ></fab-item>
              <fab-item
                :idx="2"
                title="Cancelar"
                icon="person_remove"
                color="#4285f4"
                @clickItem="manageSituation('DELETE')"
              ></fab-item>
              <fab-item
                :idx="1"
                title="Mover"
                icon="arrow_forward"
                color="#04a791"
                @clickItem="openMoveCard"
              ></fab-item>
              <fab-item
                :idx="0"
                title="Mover"
                icon="arrow_forward"
                color="#04a791"
                @clickItem="openMoveCardBoard"
              ></fab-item>
            </template>
          </vue-fab>
          <MoveCardPopover
            v-if="card && openMoveCardComponent"
            :idCurrentBoard="card.boardColumn.id"
            :boardColumns="boardColumns"
            :card="card"
            @moved="movedCard"
            @close="openMoveCardComponent = false"
            ref="moveCardPopover"
          />
          <MoveCardBoardPopover
            v-if="card && openMoveCardBoardComponent"
            :card="card"
            :oldBoardColumnId="card.boardColumn.id"
            @moved="movedCardBoard"
            @close="openMoveCardBoardComponent = false"
            ref="moveCardBoardPopover"
          />
        </div>
      </div>
      <ModalNewFollowUp
        v-if="!boardArchived && openFollowUpModal"
        ref="ModalNewFollowUp"
        :card="card"
        :isVisita="isVisita"
        :visitaId="visitaId"
        v-on:Reload="closeNewFollowUp"
      />
      <ModalCardDescription
        v-if="!boardArchived && openCardDescriptionModal"
        ref="ModalCardDescription"
        :card="card"
        v-on:Reload="closeNewCardDescription"
      />
      <ModalCardDelete
        v-if="!boardArchived"
        ref="ModalCardDelete"
        v-on:Back="closeAndUpdate"
      />
      <ModalCardLost
        v-if="!boardArchived"
        ref="ModalCardLost"
        v-on:Reload="closeAndUpdate"
      />
      <ModalCardFinish
        v-if="!boardArchived"
        ref="ModalCardFinish"
        v-on:Reload="closeAndUpdate"
      />
      <ModalAddConfirmation
      ref="ModalAddConfirmation"
      :warnText="textModalAddConfirmation"
      :saveFunction="functionModalAddConfirmation"
    />
    </b-modal>
  </div>
</template>

<script>
import ModalCard from './modalCard.js'
export default ModalCard
</script>

<style lang="scss">
.nx-scrollbar {
  scrollbar-width: thin !important;

  &::-webkit-scrollbar {
    width: 10px;
    height: 12px;
  }

  &::-webkit-scrollbar-thumb {
    border-radius: 3px;
  }
}

.nx-scrollbar-default {
  scrollbar-color: #2e6e60B3 rgba(0, 0, 0, 0.03);

  &::-webkit-scrollbar-track {
    background: rgba(0, 0, 0, 0.03);
  }

  &::-webkit-scrollbar-thumb {
    background-color: #2e6e60B3;
  }
}
</style>

<style lang="scss">
.actions__buttons__tittle {
  color: #000;
  font-size: 1.25rem;
  font-weight: 700;
  line-height: 100%;
  letter-spacing: -0.28px;
  margin-top: 2rem;
  margin-bottom: 1rem;
  text-align: center;
}

.scrollContainer {
  overflow-y: scroll;
  max-height: 100%;

  display: flex;
  flex-direction: column;
  gap: 1rem;

  padding: 0 .25rem;

  @media screen and (max-width: 480px) {
    padding: .75rem .25rem;
  }
}

.col-md-2 {
  max-height: 100%;
  overflow: hidden;
}

.modal-fullscreen .modal-dialog {
  max-width: 95vw;
  margin: 0;
  top: 5vh;
  bottom: 0;
  left: 2.5vw;
  right: 0;
  height: 90vh;
  display: flex;
  position: fixed;
  z-index: 100000;

  border-radius: 4px;
  background: #E5E5E5;

  @media screen and (max-width: 480px) {
    transform: translate(0, 3vh) !important;

    max-width: 98vw;
    top: 4vh;
    bottom: 0;
    left: 1vw;
    right: 0;
    height: 92vh;
  }

  .close__btn {
    border: none;
    background: transparent;
    font-size: 1.5rem;
    color: #6c757d;
    position: absolute;
    top: .5rem;
    right: .5rem;
    cursor: pointer;
    z-index: 100;
  }

  .modal-body {
    background: #E5E5E5;
    overflow: hidden !important;
    overflow-y: hidden !important;

    @media screen and (max-width: 480px) {
      padding: .5rem;
    }
  }
}
</style>
<!-- v-if="screenW > 768
screenW: screen.width, -->



// WEBPACK FOOTER //
// src/views/private/crm/components/modalCard/modalCard.vue